import type { ActivitySection } from '../hooks/useInspectionReportActivity';

// Flat-section fields are prefixed by section in InspectionFormValues. Anything
// unprefixed (customer details, offeredMaintenancePlan) folds into
// customer_information — coarse, but enough to answer "how far did they get?".
export function sectionForField(field: string): ActivitySection {
  if (field.startsWith('electrical')) return 'electrical';
  if (field.startsWith('waterTreatment')) return 'water_treatment';
  if (field.startsWith('airQuality')) return 'air_quality';
  return 'customer_information';
}
